<template>
  <div>
    <div class="row mt-4">
      <div class="col-4">
        <div class="form-group has-label">
          <minus-plus
          :label="`${$t('labor.hours_number_typeof')}: *`"
            @handlePlus="handlePlus"
            @handleMinus="handleMinus"
          />
        </div>
      </div>
      <div class="col-12">
        <hr class="mt-1 mb-4">
      </div>
    </div>
    <div class="row" v-for="index in model.timeType_number" :key="index">
      <div class="col-4">
        <div class="form-group has-label">
          <label v-if="index === 1">{{ $t('labor.hour_type') }}*</label>
          <br v-if="index === 1" />
          <el-select
            clearable
            filterable
            :class="`select-primary custom-width-select shadow-sm required-time-type`"
            size="large"
            v-model="model.time_type[index - 1]"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in timetypes"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-2">
        <label v-if="index === 1">{{ $t('common_words.value_additional') }}: *</label>
        <br v-if="index === 1">
        <fg-input
          class="custom-addon"
          placeholder="..."
          ref="additional_percentage"
          type="number"
          v-model="model.additional_percentage[index - 1]"
          name="common_words.value_additional_row" 
          :error="getError('common_words.value_additional_row',true , index)"
          v-validate="modelValidations.additional_percentage"
          :addonLeftIcon="getPrevSimbol(index - 1)"
          :addonRightIcon="getAfterSimbol(index - 1)"
        >
        </fg-input>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: {
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      model: {
        time_type: [],
        additional_percentage: [],
        timeType_number: 0,
      },
      modelValidations: {
        additional_percentage: {
          required: true,
        },
      },
      timetypes: [],
    };
  },

  mixins: [MixinPermissions, MixinMasters, MixinExport],

  methods: {
    getTimeType(index) {
      if (this.timetypes.length === 0) return null;
      return this.timetypes.find(type => type.id === this.model.time_type[index])
    },

    getPrevSimbol(index) {
      const type = this.getTimeType(index)

      return type && type.price_format === '$' ? 'fa fa-usd' : '';
    },
    
    getAfterSimbol(index) {
      const type = this.getTimeType(index)

      return type && type.price_format === '%' ? 'fa fa-percent' : '';
    },

    handlePlus() {
      this.model.timeType_number++;
      this.handleNumberChange();
    },

    handleMinus() {
      const minNumber = this.getNumberTimeType();
      if (this.model.timeType_number > minNumber) {
        this.model.timeType_number--;
        this.handleNumberChange();
      }
    },

    getNumberTimeType() {
      return this.model.time_type.length;
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    handleNumberChange() {
      let time_types = [...this.model.time_type];
      let additional_percentages = [...this.model.additional_percentage];
      if (
        this.model.time_type.length > 0 &&
        this.model.time_type.length > this.model.timeType_number
      ) {
        this.$set(
          this.model,
          'time_type',
          time_types.splice(0, this.model.timeType_number)
        );
        this.$set(
          this.model,
          'additional_percentage',
          additional_percentages.splice(0, this.model.timeType_number)
        );
      }
    },

    opty(dataMain, options, field = 'name') {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind[field]);
      });

      return others;
    },

    async validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          this.$emit('fillActivityValueForm', 'secondStep', {
            hourTypes: this.opty(this.model.time_type, this.timetypes),
            priceFormats: this.opty(this.model.time_type, this.timetypes, 'price_format'),
          });

          return res;
        })
        .then(async (res) => {
          if (!res) return res;
          const response = await this.validateVariousSelect(
            this.model.timeType_number,
            [this.model.time_type],
            ['time-type']
          ).then((passed) => passed.every((pass) => pass));

          return response;
        });
    },

    loadToUpdate(editForm) {
      this.model.timeType_number = editForm.times.length;
      editForm.times.forEach((element) => {
        this.model.time_type.push(element.time_type_id);
        this.model.additional_percentage.push(element.additional_percentage);
      });
    }
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('works/timetypes/field')
        .then((response) => {
          this.timetypes = response.data.data;
          this.model.timeType_number = this.timetypes.length;
          
          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            const editForm = JSON.parse(sessionStorage.getItem('editForm'));
            this.loadToUpdate(editForm);
          } else {
            this.timetypes.forEach((timeType) => {
              this.model.time_type.push(timeType.id);
              this.model.additional_percentage.push(timeType.price);
            });
          }
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },

  destroyed() {
    localStorage.removeItem('listFiles');
  },
};
</script>
</script>
